import find from 'lodash/find';
import { SET_CHAT_INTERVAL } from '../constants';
import { onlineChatIntervalsSelector } from '../examData/selectors';

export const setChatIntervalMiddleware = ({ getState }) => next => (action) => {
  if (action.type !== SET_CHAT_INTERVAL) {
    return next(action);
  }

  const state = getState();
  const chatIntervals = onlineChatIntervalsSelector(state);
  const payload = find(chatIntervals, { text: action.payload });

  return next({ type: SET_CHAT_INTERVAL, payload });
};

export default setChatIntervalMiddleware;
